import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start", // Keep label at the top
    backgroundColor: theme.palette.grey[200],
    borderRadius: theme.spacing(1),
    padding: "4px", // Reduced from theme.spacing(1) which is 8px
    margin: "8px 4px",
    boxSizing: "border-box",
    boxShadow: "0 2px 4px rgba(0,0,0,0.12)",
    overflow: "visible", // Changed from hidden to visible
  },
  label: {
    fontSize: "9px", // Slightly reduced from 10px
    fontWeight: "bold",
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginBottom: "2px", // Reduced from theme.spacing(0.5) which is 4px
    textAlign: "center",
    lineHeight: 1,
  },
  value: {
    fontSize: "16px", // Slightly reduced from 18px for better fit
    fontWeight: "bold",
    color: theme.palette.text.primary,
    flex: 1, // Take remaining space
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 1,
  },
}));

const PriceListBox = ({
  value,
  style,
  isSkeletonMode = false,
  maxHeight,
  fullHeight = false,
}) => {
  const classes = useStyles();

  // Create dynamic style with original grey background and specific blue border
  const dynamicStyle = {
    ...style,
    // Ensure pricelist box has the specific blue border
    border: "2px solid rgb(52, 152, 219)",
    ...(fullHeight && {
      height: "100%",
      width: "100%",
      minHeight: "80px", // Ensure minimum height for value visibility
    }),
    ...(maxHeight &&
      !fullHeight && {
        height: `${maxHeight}px`,
        maxHeight: `${maxHeight}px`,
      }),
    // If no maxHeight or fullHeight provided, use the old default
    ...(!maxHeight &&
      !fullHeight && {
        height: "calc(100% - 20px)",
      }),
  };

  return (
    <div className={classes.container} style={dynamicStyle}>
      <Typography className={classes.label} variant="caption">
        {isSkeletonMode ? "" : "Price List"}
      </Typography>
      <Typography className={classes.value} variant="h6">
        {isSkeletonMode ? "" : value}
      </Typography>
    </div>
  );
};

PriceListBox.propTypes = {
  value: PropTypes.number.isRequired,
  style: PropTypes.object,
  isSkeletonMode: PropTypes.bool,
  maxHeight: PropTypes.number, // Dynamic height to match scrollable content
  fullHeight: PropTypes.bool, // When true, fills 100% height of container
};

export default PriceListBox;
